/**
 * A 401 can arrive from either data layer — `useApi`'s axios or RTK Query's baseQuery — and
 * neither of them sits inside React, so neither can clear the session itself. Both announce it
 * on the window instead; the single listener lives in `useUnauthorizedRedirect`, which owns the
 * contexts that hold the token and the user.
 */
export const UNAUTHORIZED_EVENT = "app:unauthorized";

export const notifyUnauthorized = () => window.dispatchEvent(new Event(UNAUTHORIZED_EVENT));
